import React from 'react';
import { OrderSummary_PromotionFieldsFragment } from '@/types';
import { VolumePromotionOrderSummaryBadge } from './volume-promotion-order-summary-badge';

export interface AppliedVolumePromotion {
  discountInMicros: number;
  promotion: OrderSummary_PromotionFieldsFragment;
}

interface Props {
  appliedPromotions: AppliedVolumePromotion[];
  currencyCode: string | null;
}

export const OrderSummaryPromotions: React.FC<Props> = ({
  appliedPromotions,
  currencyCode,
}) => {
  return appliedPromotions.map((promotion) => (
    <VolumePromotionOrderSummaryBadge
      calculatedDiscountInMicros={promotion.discountInMicros}
      currencyCode={currencyCode}
      key={promotion.promotion.uuid}
      promotion={promotion.promotion}
    />
  ));
};
